import { useEffect, useRef, useState, type RefCallback } from 'react';

/** Плавно прокручивает список к карточке, которая появилась после создания. */
export function useCreatedItemScroll<T extends HTMLElement>(
  itemIds: readonly string[],
): {
  readonly scrollToCreatedItem: (id: string) => void;
  readonly itemRef: (id: string) => RefCallback<T>;
} {
  const nodes = useRef(new Map<string, T>());
  const [targetId, setTargetId] = useState<string | null>(null);

  useEffect(() => {
    if (!targetId || !itemIds.includes(targetId)) return;
    const node = nodes.current.get(targetId);
    if (!node) return;
    node.scrollIntoView?.({ behavior: 'smooth', block: 'start' });
    setTargetId(null);
  }, [itemIds, targetId]);

  return {
    scrollToCreatedItem: setTargetId,
    itemRef: (id) => (node) => {
      if (node) nodes.current.set(id, node);
      else nodes.current.delete(id);
    },
  };
}
